import * as Sentry from "@sentry/browser/esm";

Sentry.init({
    dsn: "https://5b0e520f0d074fcd9ffcedd656e27803@sentry.weborigo.eu/3",
    tracesSampleRate: 0.7,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
});
